import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import { BookOpen, Link2, LucideIcon, NotepadText, Users } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import { RachelMessageReference } from '../../../../rachel.types';

const ICON_BY_ENTITY: Partial<Record<string, LucideIcon>> = {
  orders: NotepadText,
  customers: Users,
  catalogs: BookOpen,
};

interface RachelMessageReferenceChipProps {
  reference: RachelMessageReference;
}

const RachelMessageReferenceChip = ({ reference }: RachelMessageReferenceChipProps) => {
  const history = useHistory();

  return (
    <Chip
      clickable
      size="small"
      testId="rachel-message-reference"
      label={reference.label}
      title={reference.label}
      icon={<Icon icon={ICON_BY_ENTITY[reference.entity] ?? Link2} size="xs" />}
      sx={{ maxWidth: '100%' }}
      onClick={() => history.push(reference.pathname)}
    />
  );
};

export default RachelMessageReferenceChip;
